module.exports = __webpack_public_path__ + "static/media/mssqlserver.54d7bddc.svg";